// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.teamContainer_pvmW3 {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.colaboratorsContainer_N6rYl {
  display: flex;
  align-items: center;
  gap: 10px;
  .inputWrapper_FsXNA {
    flex: 1 1;
    display: flex;
    align-items: center;
    background-color: var(--f4-background);
    box-sizing: border-box;
    padding: 12px;
    border-radius: 6px;
    -webkit-border-radius: 6px;
    -moz-border-radius: 6px;
    -ms-border-radius: 6px;
    -o-border-radius: 6px;
    input {
      background-color: transparent;
      border: none;
      outline: none;
    }
  }
}

.yourAccountInfo_aEBS8 {
  display: flex;
  align-items: center;
  gap: 10px;

  .info_ZC9VA {
    color: #717171;
  }
  p {
    margin: 0;
  }
}

.initial_N9SaA {
  background-color: #233f39;
  height: 33px;
  min-width: 33px;
  max-width: 33px;
  border-radius: 999px;
  -webkit-border-radius: 999px;
  -moz-border-radius: 999px;
  -ms-border-radius: 999px;
  -o-border-radius: 999px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--white-background);
}

.accounts_VzOnI {
  border: 1px solid #d9d9e3;
  border-radius: 8px;
  -webkit-border-radius: 8px;
  -moz-border-radius: 8px;
  -ms-border-radius: 8px;
  -o-border-radius: 8px;
  .account_F6GYG {
    border-bottom: 1px solid #d9d9e3;
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 6px;
    justify-content: space-between;
    svg {
      cursor: pointer;
    }
    .container_JKxcZ {
      display: flex;
      align-items: center;
      gap: 10px;
    }
    .infoAccount_ZBMj0 {
      .row_IJ9gz {
        display: flex;
        align-items: center;
        gap: 10px;
        color: #717171;
        .state_p68Ix {
          background-color: #ffcf63;
          color: var(--white-background);
          padding: 4px;
          border-radius: 4px;
          -webkit-border-radius: 4px;
          -moz-border-radius: 4px;
          -ms-border-radius: 4px;
          -o-border-radius: 4px;
        }
        p {
          margin: 0;
        }
      }
    }
  }
}

.restricted_QEiR1 {
  color: #6e6e80;
  background-color: var(--ececf1-background);
  border-radius: 4px;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  -ms-border-radius: 4px;
  -o-border-radius: 4px;
  padding: 2px;
}

.full_GHkn9 {
  color: var(--_10a37f-background);
}
.advance_PAGOa {
  border: 1px solid #00000026;
  border-radius: 999px;
  -webkit-border-radius: 999px;
  -moz-border-radius: 999px;
  -ms-border-radius: 999px;
  -o-border-radius: 999px;
  padding: 4px 6px;
}
.noAccess_igr7_ {
  color: #767575;
}
.teamInvitation_Uxr4i {
  width: 90%;
  background-color: var(--white-background);
  margin: 0 auto;
  padding: 8px;
  display: flex;
  flex-direction: column;
  gap: 5px;
  max-height: 75vh;
  overflow-y: scroll;
  .row_IJ9gz {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }
  span {
    color: #717171;
    font-size: 13px;
  }
  .inputWrapper_FsXNA {
    width: 50%;
    display: flex;
    align-items: center;
    background-color: var(--f4-background);
    box-sizing: border-box;
    padding: 6px;
    border-radius: 6px;
    -webkit-border-radius: 6px;
    -moz-border-radius: 6px;
    -ms-border-radius: 6px;
    -o-border-radius: 6px;
    svg {
      height: 25px;
      width: 25px;
    }
    input {
      background-color: transparent;
      border: none;
      outline: none;
    }
  }

  .optionsTeamInvitation_TXLD1 {
    display: flex;
    flex-direction: column;
    gap: 10px;
    border-bottom: 1px solid #d9d9e3;
    padding: 20px 0;
    .access_J0rlq {
      display: flex;
      align-items: center;
      gap: 10px;
    }
    .option_u_azh {
      display: flex;
      align-items: center;
      gap: 10px;
      label {
        margin-bottom: 0;
      }
      span {
        color: #717171;
      }
      p {
        margin: 0;
        color: #0d0d0d;
      }
    }
  }
}

.toggleSwitch_UcaKg {
  position: relative;
  display: inline-block;
  width: 40px;
  height: 24px;
}

.toggleSwitch_UcaKg input {
  opacity: 0;
  width: 0 !important;
  height: 0 !important;
}

.slider_ScZfF {
  position: absolute;
  cursor: pointer;
  background-color: #ccc;
  border-radius: 24px;
  width: 100%;
  height: 100%;
  transition: background-color 0.3s;
}

.slider_ScZfF::before {
  content: "";
  position: absolute;
  height: 20px;
  width: 20px;
  left: 4px;
  bottom: 2px;
  background-color: var(--white-color);
  border-radius: 50%;
  transition: transform 0.3s;
}

.toggleSwitch_UcaKg input:checked + .slider_ScZfF {
  background-color: #000000;
}

.toggleSwitch_UcaKg input:checked + .slider_ScZfF::before {
  transform: translateX(14px);
  -webkit-transform: translateX(14px);
  -moz-transform: translateX(14px);
  -ms-transform: translateX(14px);
  -o-transform: translateX(14px);
}
.timeTeamInvitation_N3oH9 {
  .row_IJ9gz {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    p {
      margin: 0;
    }
    span {
      color: #717171;
    }
  }
}

.days_FG1_E {
  display: flex;
  flex-direction: column;
  gap: 15px;
  border-bottom: 1px solid #d9d9e3;
  padding: 20px 0;
  .row_IJ9gz {
    > div {
      display: flex;
      align-items: center;
      gap: 10px;
    }
  }
}

.addBtn_fAYS3 {
  border: 1px solid #b1b1b1;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  max-width: 20px;
  height: 20px;
  border-radius: 999px;
  -webkit-border-radius: 999px;
  -moz-border-radius: 999px;
  -ms-border-radius: 999px;
  -o-border-radius: 999px;
  box-sizing: border-box;
}

.holidaysHeader_LPCAU {
  display: flex;
  align-items: center;
  .selectHolidays_zbDQn {
    display: flex;
    align-items: center;
    gap: 5px;
  }
  p {
    margin: 0;
  }
}

.holidays_IOmv0 {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 20px 0;
  border-bottom: 1px solid #d9d9e3;
  p {
    margin: 0;
  }
  .tagHolidaysContainer_YAsFs {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
  }
  .tagHoliday_hFk5I {
    border: 1px solid #e0e3e6;
    width: fit-content;
    display: flex;
    align-items: center;
    padding: 4px;
    border-radius: 999px;
    -webkit-border-radius: 999px;
    -moz-border-radius: 999px;
    -ms-border-radius: 999px;
    -o-border-radius: 999px;
  }
}

.signature_iayFy{
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  border-bottom: 1px solid #d9d9e3;
  padding: 20px 0;
  p{
    margin: 0;
  }
.DeleteButtonContainer_jbOoM{
  position: absolute;
  top: -5px;
  right: -5px;
  cursor: pointer;
}
  .signatureContainer_lY_Ty{
    .signatureImage__4Khc{
      width: 50px;
      height: 50px;
    }
  }
}
.deleteContact_FrRfY {
  width: 95%;
  margin: 20px 0;
  display: flex;
  align-items: center;
  justify-content: end;
  color: #dc3545;
  gap: 7px;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 16.9px; 
  cursor: pointer;
  .icon_yKomU {
    display: flex;
    padding: 5px;
    align-items: center;
    gap: 10px;
    border-radius: 200px;
    background: #ededed;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/GeneralSettings/components/Team/Team.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT;IACE,SAAO;IACP,aAAa;IACb,mBAAmB;IACnB,sCAAsC;IACtC,sBAAsB;IACtB,aAAa;IACb,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;IACrB;MACE,6BAA6B;MAC7B,YAAY;MACZ,aAAa;IACf;EACF;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;;EAET;IACE,cAAc;EAChB;EACA;IACE,SAAS;EACX;AACF;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,4BAA4B;EAC5B,yBAAyB;EACzB,wBAAwB;EACxB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;EACrB;IACE,gCAAgC;IAChC,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,YAAY;IACZ,8BAA8B;IAC9B;MACE,eAAe;IACjB;IACA;MACE,aAAa;MACb,mBAAmB;MACnB,SAAS;IACX;IACA;MACE;QACE,aAAa;QACb,mBAAmB;QACnB,SAAS;QACT,cAAc;QACd;UACE,yBAAyB;UACzB,8BAA8B;UAC9B,YAAY;UACZ,kBAAkB;UAClB,0BAA0B;UAC1B,uBAAuB;UACvB,sBAAsB;UACtB,qBAAqB;QACvB;QACA;UACE,SAAS;QACX;MACF;IACF;EACF;AACF;;AAEA;EACE,cAAc;EACd,0CAA0C;EAC1C,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,gCAAgC;AAClC;AACA;EACE,2BAA2B;EAC3B,oBAAoB;EACpB,4BAA4B;EAC5B,yBAAyB;EACzB,wBAAwB;EACxB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,UAAU;EACV,yCAAyC;EACzC,cAAc;EACd,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;EACb;EACA;IACE,cAAc;IACd,eAAe;EACjB;EACA;IACE,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,sCAAsC;IACtC,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;IACrB;MACE,YAAY;MACZ,WAAW;IACb;IACA;MACE,6BAA6B;MAC7B,YAAY;MACZ,aAAa;IACf;EACF;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gCAAgC;IAChC,eAAe;IACf;MACE,aAAa;MACb,mBAAmB;MACnB,SAAS;IACX;IACA;MACE,aAAa;MACb,mBAAmB;MACnB,SAAS;MACT;QACE,gBAAgB;MAClB;MACA;QACE,cAAc;MAChB;MACA;QACE,SAAS;QACT,cAAc;MAChB;IACF;EACF;AACF;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,oCAAoC;EACpC,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,mCAAmC;EACnC,gCAAgC;EAChC,+BAA+B;EAC/B,8BAA8B;AAChC;AACA;EACE;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;IACX;MACE,SAAS;IACX;IACA;MACE,cAAc;IAChB;EACF;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gCAAgC;EAChC,eAAe;EACf;IACE;MACE,aAAa;MACb,mBAAmB;MACnB,SAAS;IACX;EACF;AACF;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,YAAY;EACZ,oBAAoB;EACpB,4BAA4B;EAC5B,yBAAyB;EACzB,wBAAwB;EACxB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;EACV;EACA;IACE,SAAS;EACX;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;EACf,gCAAgC;EAChC;IACE,SAAS;EACX;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,SAAS;EACX;EACA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,oBAAoB;IACpB,4BAA4B;IAC5B,yBAAyB;IACzB,wBAAwB;IACxB,uBAAuB;EACzB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf;IACE,SAAS;EACX;AACF;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;AACjB;EACE;IACE;MACE,WAAW;MACX,YAAY;IACd;EACF;AACF;AACA;EACE,UAAU;EACV,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;EACd,QAAQ;EACR,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf;IACE,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,SAAS;IACT,oBAAoB;IACpB,mBAAmB;EACrB;AACF","sourcesContent":[".teamContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n.colaboratorsContainer {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  .inputWrapper {\n    flex: 1;\n    display: flex;\n    align-items: center;\n    background-color: var(--f4-background);\n    box-sizing: border-box;\n    padding: 12px;\n    border-radius: 6px;\n    -webkit-border-radius: 6px;\n    -moz-border-radius: 6px;\n    -ms-border-radius: 6px;\n    -o-border-radius: 6px;\n    input {\n      background-color: transparent;\n      border: none;\n      outline: none;\n    }\n  }\n}\n\n.yourAccountInfo {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n\n  .info {\n    color: #717171;\n  }\n  p {\n    margin: 0;\n  }\n}\n\n.initial {\n  background-color: #233f39;\n  height: 33px;\n  min-width: 33px;\n  max-width: 33px;\n  border-radius: 999px;\n  -webkit-border-radius: 999px;\n  -moz-border-radius: 999px;\n  -ms-border-radius: 999px;\n  -o-border-radius: 999px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--white-background);\n}\n\n.accounts {\n  border: 1px solid #d9d9e3;\n  border-radius: 8px;\n  -webkit-border-radius: 8px;\n  -moz-border-radius: 8px;\n  -ms-border-radius: 8px;\n  -o-border-radius: 8px;\n  .account {\n    border-bottom: 1px solid #d9d9e3;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 6px;\n    justify-content: space-between;\n    svg {\n      cursor: pointer;\n    }\n    .container {\n      display: flex;\n      align-items: center;\n      gap: 10px;\n    }\n    .infoAccount {\n      .row {\n        display: flex;\n        align-items: center;\n        gap: 10px;\n        color: #717171;\n        .state {\n          background-color: #ffcf63;\n          color: var(--white-background);\n          padding: 4px;\n          border-radius: 4px;\n          -webkit-border-radius: 4px;\n          -moz-border-radius: 4px;\n          -ms-border-radius: 4px;\n          -o-border-radius: 4px;\n        }\n        p {\n          margin: 0;\n        }\n      }\n    }\n  }\n}\n\n.restricted {\n  color: #6e6e80;\n  background-color: var(--ececf1-background);\n  border-radius: 4px;\n  -webkit-border-radius: 4px;\n  -moz-border-radius: 4px;\n  -ms-border-radius: 4px;\n  -o-border-radius: 4px;\n  padding: 2px;\n}\n\n.full {\n  color: var(--_10a37f-background);\n}\n.advance {\n  border: 1px solid #00000026;\n  border-radius: 999px;\n  -webkit-border-radius: 999px;\n  -moz-border-radius: 999px;\n  -ms-border-radius: 999px;\n  -o-border-radius: 999px;\n  padding: 4px 6px;\n}\n.noAccess {\n  color: #767575;\n}\n.teamInvitation {\n  width: 90%;\n  background-color: var(--white-background);\n  margin: 0 auto;\n  padding: 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  max-height: 75vh;\n  overflow-y: scroll;\n  .row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n  }\n  span {\n    color: #717171;\n    font-size: 13px;\n  }\n  .inputWrapper {\n    width: 50%;\n    display: flex;\n    align-items: center;\n    background-color: var(--f4-background);\n    box-sizing: border-box;\n    padding: 6px;\n    border-radius: 6px;\n    -webkit-border-radius: 6px;\n    -moz-border-radius: 6px;\n    -ms-border-radius: 6px;\n    -o-border-radius: 6px;\n    svg {\n      height: 25px;\n      width: 25px;\n    }\n    input {\n      background-color: transparent;\n      border: none;\n      outline: none;\n    }\n  }\n\n  .optionsTeamInvitation {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    border-bottom: 1px solid #d9d9e3;\n    padding: 20px 0;\n    .access {\n      display: flex;\n      align-items: center;\n      gap: 10px;\n    }\n    .option {\n      display: flex;\n      align-items: center;\n      gap: 10px;\n      label {\n        margin-bottom: 0;\n      }\n      span {\n        color: #717171;\n      }\n      p {\n        margin: 0;\n        color: #0d0d0d;\n      }\n    }\n  }\n}\n\n.toggleSwitch {\n  position: relative;\n  display: inline-block;\n  width: 40px;\n  height: 24px;\n}\n\n.toggleSwitch input {\n  opacity: 0;\n  width: 0 !important;\n  height: 0 !important;\n}\n\n.slider {\n  position: absolute;\n  cursor: pointer;\n  background-color: #ccc;\n  border-radius: 24px;\n  width: 100%;\n  height: 100%;\n  transition: background-color 0.3s;\n}\n\n.slider::before {\n  content: \"\";\n  position: absolute;\n  height: 20px;\n  width: 20px;\n  left: 4px;\n  bottom: 2px;\n  background-color: var(--white-color);\n  border-radius: 50%;\n  transition: transform 0.3s;\n}\n\n.toggleSwitch input:checked + .slider {\n  background-color: #000000;\n}\n\n.toggleSwitch input:checked + .slider::before {\n  transform: translateX(14px);\n  -webkit-transform: translateX(14px);\n  -moz-transform: translateX(14px);\n  -ms-transform: translateX(14px);\n  -o-transform: translateX(14px);\n}\n.timeTeamInvitation {\n  .row {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n    p {\n      margin: 0;\n    }\n    span {\n      color: #717171;\n    }\n  }\n}\n\n.days {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n  border-bottom: 1px solid #d9d9e3;\n  padding: 20px 0;\n  .row {\n    > div {\n      display: flex;\n      align-items: center;\n      gap: 10px;\n    }\n  }\n}\n\n.addBtn {\n  border: 1px solid #b1b1b1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 20px;\n  max-width: 20px;\n  height: 20px;\n  border-radius: 999px;\n  -webkit-border-radius: 999px;\n  -moz-border-radius: 999px;\n  -ms-border-radius: 999px;\n  -o-border-radius: 999px;\n  box-sizing: border-box;\n}\n\n.holidaysHeader {\n  display: flex;\n  align-items: center;\n  .selectHolidays {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n  }\n  p {\n    margin: 0;\n  }\n}\n\n.holidays {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  padding: 20px 0;\n  border-bottom: 1px solid #d9d9e3;\n  p {\n    margin: 0;\n  }\n  .tagHolidaysContainer {\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 10px;\n  }\n  .tagHoliday {\n    border: 1px solid #e0e3e6;\n    width: fit-content;\n    display: flex;\n    align-items: center;\n    padding: 4px;\n    border-radius: 999px;\n    -webkit-border-radius: 999px;\n    -moz-border-radius: 999px;\n    -ms-border-radius: 999px;\n    -o-border-radius: 999px;\n  }\n}\n\n.signature{\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  position: relative;\n  border-bottom: 1px solid #d9d9e3;\n  padding: 20px 0;\n  p{\n    margin: 0;\n  }\n.DeleteButtonContainer{\n  position: absolute;\n  top: -5px;\n  right: -5px;\n  cursor: pointer;\n}\n  .signatureContainer{\n    .signatureImage{\n      width: 50px;\n      height: 50px;\n    }\n  }\n}\n.deleteContact {\n  width: 95%;\n  margin: 20px 0;\n  display: flex;\n  align-items: center;\n  justify-content: end;\n  color: #dc3545;\n  gap: 7px;\n  font-family: Inter;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 16.9px; \n  cursor: pointer;\n  .icon {\n    display: flex;\n    padding: 5px;\n    align-items: center;\n    gap: 10px;\n    border-radius: 200px;\n    background: #ededed;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"teamContainer": `teamContainer_pvmW3`,
	"colaboratorsContainer": `colaboratorsContainer_N6rYl`,
	"inputWrapper": `inputWrapper_FsXNA`,
	"yourAccountInfo": `yourAccountInfo_aEBS8`,
	"info": `info_ZC9VA`,
	"initial": `initial_N9SaA`,
	"accounts": `accounts_VzOnI`,
	"account": `account_F6GYG`,
	"container": `container_JKxcZ`,
	"infoAccount": `infoAccount_ZBMj0`,
	"row": `row_IJ9gz`,
	"state": `state_p68Ix`,
	"restricted": `restricted_QEiR1`,
	"full": `full_GHkn9`,
	"advance": `advance_PAGOa`,
	"noAccess": `noAccess_igr7_`,
	"teamInvitation": `teamInvitation_Uxr4i`,
	"optionsTeamInvitation": `optionsTeamInvitation_TXLD1`,
	"access": `access_J0rlq`,
	"option": `option_u_azh`,
	"toggleSwitch": `toggleSwitch_UcaKg`,
	"slider": `slider_ScZfF`,
	"timeTeamInvitation": `timeTeamInvitation_N3oH9`,
	"days": `days_FG1_E`,
	"addBtn": `addBtn_fAYS3`,
	"holidaysHeader": `holidaysHeader_LPCAU`,
	"selectHolidays": `selectHolidays_zbDQn`,
	"holidays": `holidays_IOmv0`,
	"tagHolidaysContainer": `tagHolidaysContainer_YAsFs`,
	"tagHoliday": `tagHoliday_hFk5I`,
	"signature": `signature_iayFy`,
	"DeleteButtonContainer": `DeleteButtonContainer_jbOoM`,
	"signatureContainer": `signatureContainer_lY_Ty`,
	"signatureImage": `signatureImage__4Khc`,
	"deleteContact": `deleteContact_FrRfY`,
	"icon": `icon_yKomU`
};
export default ___CSS_LOADER_EXPORT___;
